import "../assets/stylesheets/application.css";
// Entry point for the build script in your package.json
import "./controllers"
import '@splidejs/splide/dist/css/splide.min.css'




import "@hotwired/turbo-rails"
import "@rails/ujs"

document.addEventListener('turbo:load', () => {
  const textarea = document.querySelector('textarea'); // Adjust selector as needed
  if (textarea) {
    const previewContainer = document.createElement('div');
    previewContainer.id = 'link-preview-container';
    if (textarea.parentNode) {
      textarea.parentNode.insertBefore(previewContainer, textarea.nextSibling);
    }

    let timeout = null;

    textarea.addEventListener('input', (event) => {
      clearTimeout(timeout);
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const urlMatch = event.target.value.match(urlRegex);

      if (urlMatch) {
        const url = urlMatch[0];
        timeout = setTimeout(() => {
          fetch(`/link_preview?url=${encodeURIComponent(url)}`)
            .then(response => response.json())
            .then(data => {
              if (data.error) {
                previewContainer.innerHTML = `<p class="text-red-500">${data.error}</p>`;
              } else {
                previewContainer.innerHTML = `
                  <div class="border p-4 my-2 rounded-lg shadow-md">
                    <h3 class="font-bold text-lg">${data.title}</h3>
                    <p class="text-gray-600 text-sm">${data.description}</p>
                    ${data.image ? `<img src="${data.image}" class="mt-2 max-h-32 object-cover rounded-md">` : ''}
                    <a href="${data.url}" target="_blank" class="text-blue-500 hover:underline text-sm mt-2 block">${data.url}</a>
                  </div>
                `;
              }
            })
            .catch(error => {
              console.error('Error fetching link preview:', error);
              previewContainer.innerHTML = '<p class="text-red-500">Error loading preview.</p>';
            });
        }, 500);
      } else {
        previewContainer.innerHTML = '';
      }
    });
  }
});
